/**
 * GlobalMatchScore - Tracks global victories across Ronda and Baciga games.
 * Shared between both game types.
 */
class GlobalMatchScore {
    constructor(initialScores = null) {
        this.team1Score = initialScores?.team1 || 0;
        this.team2Score = initialScores?.team2 || 0;
        this.listeners = [];
    }

    /**
     * Add a win for a team
     * @param {1|2} teamId - Team 1 or Team 2
     */
    addWin(teamId) {
        if (teamId === 1) {
            this.team1Score++;
        } else if (teamId === 2) {
            this.team2Score++;
        }
        this._notifyListeners();
    }

    /**
     * Get current scores
     * @returns {{ team1: number, team2: number }}
     */
    getScores() {
        return {
            team1: this.team1Score,
            team2: this.team2Score
        };
    }

    /**
     * Reset all scores to 0
     */
    reset() {
        this.team1Score = 0;
        this.team2Score = 0;
        this._notifyListeners();
    }

    /**
     * Subscribe to score changes
     * @param {Function} callback - Called when scores change
     * @returns {Function} Unsubscribe function
     */
    subscribe(callback) {
        this.listeners.push(callback);
        return () => {
            this.listeners = this.listeners.filter(l => l !== callback);
        };
    }

    /**
     * Notify all listeners of score changes
     * @private
     */
    _notifyListeners() {
        const scores = this.getScores();
        this.listeners.forEach(callback => callback(scores));
    }
}

export default GlobalMatchScore;
